export default {
  customers: [],
  customer: null
}
